const normalizeQuantity = (value, maxDecimals = 3) => {
  if (value === '' || value == null) return 0;
  const normalized = typeof value === 'string' ? value.replace(',', '.') : value;
  let num = Number(normalized);
  if (!Number.isFinite(num)) return 0;
  if (num < 0) num = 0;
  if (Number.isFinite(maxDecimals)) {
    const factor = 10 ** maxDecimals;
    num = Math.round(num * factor) / factor;
  }
  return num;
};

export { normalizeQuantity };
